module.exports = "/_next/static/images/united-card-0d289750245eef105a06838a0673d7c8.png";